import React from 'react'
import StencilBox from '../../stencils/StencilBox';

function KnowledgeCardStencil() {
    return (
        <article className="knowledge-card w-100">

            {/* ACTIONS */}
            <div className="">


                <h3 className="placeholder-glow mb--0">
                    <span className="placeholder w-75"></span>
                </h3>

                <h3 className="placeholder-glow mb--0">
                    <span className="placeholder w-75"></span>
                </h3>

            </div>


            {/* CONTENT */}
            <div className="content w-100">
                {/* Title Skeleton */}
                <h2 className="placeholder-glow mb--0">
                    <span className="placeholder w-100"></span>
                </h2>
                <h4 className="placeholder-glow mb--0">
                    <span className="placeholder w-100"></span>
                </h4>
            </div>


            {/* META */}
            <div className="knowledge-card-meta">

                <h6 className="placeholder-glow mb--0">
                    <span className="placeholder w-100"></span>
                </h6>

                <h6 className="placeholder-glow mb--0">
                    <span className="placeholder w-100"></span>
                </h6>


                <h6 className="placeholder-glow mb--0">
                    <span className="placeholder w-100"></span>
                </h6>
            </div>
        </article>
    )
}

export default KnowledgeCardStencil
